import { render, staticRenderFns } from "./project_dashboard.vue?vue&type=template&id=03e65c69&scoped=true&"
import script from "./project_dashboard.vue?vue&type=script&lang=js&"
export * from "./project_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./project_dashboard.vue?vue&type=style&index=0&id=03e65c69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e65c69",
  null
  
)

export default component.exports